// Google Analytics 4 (gtag.js) para una SPA.
//
// El ID de medición se lee de la variable de entorno REACT_APP_GA_ID
// (formato G-XXXXXXXXXX). Si no está definida, GA queda desactivado (útil en
// dev y en el prerender).
//
// Notas:
//  - No inicializa durante el prerender (Chrome headless pone
//    navigator.webdriver = true), para no contaminar las métricas ni hornear
//    el script de GA en el HTML estático.
//  - send_page_view: false → los page_view los enviamos manualmente en cada
//    cambio de ruta de react-router (ver usePageTracking).

export const GA_ID = process.env.REACT_APP_GA_ID || '';

const isPrerender = () =>
  typeof navigator !== 'undefined' && navigator.webdriver === true;

let initialized = false;

export const initGA = () => {
  if (initialized) return;
  if (!GA_ID) return;
  if (typeof window === 'undefined') return;
  if (isPrerender()) return;

  // Carga del script de gtag.
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  // gtag debe usar 'arguments' (no rest args) por cómo lo consume GA.
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  // El page_view inicial y los de navegación los mandamos nosotros.
  gtag('config', GA_ID, { send_page_view: false });

  initialized = true;
};

export const trackPageView = (path) => {
  if (!GA_ID || isPrerender()) return;
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
